// Shared by BillingMigrationModal and anything else that needs to reason
// about the NZ -> Atlas billing migration prompt (see
// scripts/stripe-nz-to-atlas/README.md).
//
// The schedule is derived entirely from nzMigration.requiredFrom on the
// tenant's subscription doc:
//   notice   until 14 days before the deadline: dismiss snoozes for 7 days
//   warning  the last 14 days: shows every login, dismiss snoozes 12 hours
//   blocked  from the deadline: cannot be dismissed until Checkout completes

export type MigrationStage = "notice" | "warning" | "blocked";

export const MIGRATION_WARN_WINDOW_MS = 14 * 24 * 60 * 60 * 1000;
export const MIGRATION_NOTICE_SNOOZE_MS = 7 * 24 * 60 * 60 * 1000;
export const MIGRATION_WARNING_SNOOZE_MS = 12 * 60 * 60 * 1000;

export const migrationStageFor = (
  requiredFrom: number,
  now: number = Date.now()
): MigrationStage => {
  if (now >= requiredFrom) return "blocked";
  if (now >= requiredFrom - MIGRATION_WARN_WINDOW_MS) return "warning";
  return "notice";
};

export const migrationSnoozeMsFor = (stage: MigrationStage): number =>
  stage === "notice" ? MIGRATION_NOTICE_SNOOZE_MS : MIGRATION_WARNING_SNOOZE_MS;
